import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { loadBlockedDevices } from './blockedDeviceData'
import type { BlockedDeviceQuery } from './blockedDeviceTypes'

/** Blocked Device Ids — live Keycloak → Agent-API `playersWithBlockedDevices`. */
export function useBlockedDevices(query: BlockedDeviceQuery) {
  return useQuery({
    queryKey: keys.blockedDevices(query),
    queryFn: () => loadBlockedDevices(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
